export const getAllPractitionerListConfig = () => ({
  url: `/get_all_practitioner_condition`,
});

export const addPractitionerConfig = () => ({
  url: `/new_practitioner`,
});

export const getPractitionerByIdConfig = (id) => ({
  url: `/get_practitioner_condition/${id}`,
});

export const editPractitionerConfig = () => ({
  url: `/update_practitioner_condition`,
});

export const getPractitionersOrgLevelConfig = () => ({
  url: `/practitioners_org_level`,
});

export const getPromptByConditionConfig = () => ({
  url: `/prompt_by_condition`,
});

export const getAutoGeneratePractitionerDetailsConfig = () => ({
  url: `/get_practitioner_details`,
});

export const specialtyConditionConfig = () => ({
  url: `/specialtyConditions`,
});

export const offBoardPractitionerConfig = (practitionerId) => ({
  url: `/offboard_practitioner/${practitionerId}`,
});

export const getFronteggRolesConfig = () => ({
  url: `/frontegg_roles`,
});
